import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { ScorecardAtom } from "../../../../../State/Scorecard.Atom";
import { DeviationsService } from "../../../../../Component/Api/EmploymentEquity/WorkforceProfileGoalsAndTargets/DeviationsService";
import { DataTable } from "../../../../../Component/Common/Components/DataTable/DataTable";
import { DeviationModal } from "./DeviationModal";
import { EEOccupationalLevel } from "../../../../../Component/Model/Enum/EmploymentEquity";
import { ConfirmationDialog } from "../../../../../Component/Common/Components/ConfirmationDialog";
import { Deviation } from "../../../../../Component/Model/Dto/EmploymentEquity/Plan/Deviation";
import { DeviationsTableMapper } from "./DeviationsTableColumn";
import { Dialog, DialogContent } from "@mui/material";
import { CustomDialogTitle } from "../../../../Common/Custom/CustomDialogTitle";
import { SmallLoading } from "../../../../../Component/Common/Components/Loading/IntermediateLoading";
import { PortalDocuments } from "../../../../Common/PortalDocuments/PortalDocuments";

interface IProps {
    occupationalLevel: EEOccupationalLevel;
    isDisabled: boolean;
    year: number;
    scorecardId: string;
    showModal: boolean;
    handleCancel: () => void;
}

export const DeviationsTableModal = (props: IProps) => {
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [documentsPopUp, setDocumentsPopUp] = React.useState<boolean>(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = React.useState<boolean>(false);
    const [deviationsData, setDeviationsData] = React.useState<Deviation.SearchResultDto[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [selectedDeviationId, setSelectedDeviationId] = React.useState<number | undefined>();
    const [selectedDocumentId, setSelectedDocumentId] = React.useState<number>();
    const scorecard = useRecoilValue(ScorecardAtom);
    const scorecardId = scorecard.scorecardId;

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDeviationId(undefined);
        fetchData();
    }

    const handleCloseConfirmation = () => {
        setShowConfirmationDialog(false);
        setSelectedDeviationId(undefined);
    }

    const handleEdit = (id: number) => {
        setSelectedDeviationId(id);
        setShowModal(true);
    }

    const handleConfirmDelete = (id: number) => {
        setSelectedDeviationId(id);
        setShowConfirmationDialog(true);
    }

    const handleDelete = async () => {
        
        try {
            await DeviationsService.DeleteDeviation(selectedDeviationId!);
            toast.success("Deviation deleted succesfully")
            fetchData();

        } catch (error) {
            console.log(error)
        }
        handleCloseConfirmation();

    }

    const handleAttachedSD = (id: number) => {
        setSelectedDocumentId(id);
        setDocumentsPopUp(true);
    }

    const onDocumentPopupClose = () => {
        setDocumentsPopUp(false);
        fetchData();
    }

    const deviationsSearchRequest: Deviation.SearchRequest = {
        scorecardId: scorecardId,
        isDisabled: props.isDisabled,
        occupationalLevelType: props.occupationalLevel,
        year: props.year
    };

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let searchResult = await DeviationsService.SearchDeviations(deviationsSearchRequest);
            if (searchResult.data) {
                setDeviationsData(searchResult.data.results);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        fetchData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const bulkActions = [
        {
            label: "Add Deviation",
            action: () => {setSelectedDeviationId(undefined);
                 setShowModal(true);
                }
        }
    ]

    const deviationsTableData = DeviationsTableMapper(deviationsData, handleEdit, handleConfirmDelete, handleAttachedSD);
    return (
        <>
        <Dialog open={props.showModal} onClose={props.handleCancel} aria-labelledby="form-dialog-title" maxWidth='lg' fullWidth>
            <CustomDialogTitle id="customized-dialog-title" onClose={props.handleCancel}>
                Deviations
            </CustomDialogTitle>
            <DialogContent>
                <DataTable
                    key={"DeviationsTable"}
                    table={deviationsTableData}
                    isLoading={isLoading}
                    bulkActions={bulkActions}
                    manualSorting={false}
                    canSearch={false}
                    showEntriesPerPage={false}
                    showTotalEntries={false}
                    showBottomMargin={false}
                ></DataTable>  
            </DialogContent>
        </Dialog>

            {showModal && 
                <DeviationModal
                    showModal={showModal}
                    id={selectedDeviationId}
                    scorecardId={scorecardId}
                    handleCancel={handleCloseModal}
                    year={props.year}
                    occupationalLevel={props.occupationalLevel}
                    isDisabled={props.isDisabled}
                />
            }

            {documentsPopUp && 
                <PortalDocuments
                    display={documentsPopUp} 
                    handleCancel={() => onDocumentPopupClose()} 
                    link={"deviation"} 
                    id={selectedDocumentId!} 
                />
            }

            <ConfirmationDialog
                showDialog={showConfirmationDialog}
                handleAccept={handleDelete}
                handleCancel={handleCloseConfirmation}
                heading={"Delete Deviation"}
                message={"Are you sure you want to delete this deviation and associated files?"}
            />
        </>
    )
}